import { Box } from '@air/zephyr';

import { CuratedAgencyCard } from '~/old-marketing/components/agency/CuratedAgencyCard';
import { LimitedAgencyData } from '~/old-marketing/components/types/custom-types';

export interface CuratedAgenciesListProps {
  agencies?: LimitedAgencyData[];
}

export const CuratedAgenciesList = ({ agencies }: CuratedAgenciesListProps) => {
  return (
    <Box tx={{ display: 'grid', gap: [16, 24], gridTemplateColumns: ['repeat(2, 1fr)', 'repeat(4, 1fr)'] }}>
      {agencies?.map((agency) => (
        <CuratedAgencyCard image={agency.logos?.[0]} key={agency.id} name={agency.name} slug={agency.slug} />
      ))}
    </Box>
  );
};
